export default __webpack_public_path__ + "static/screeny-110-gc-cabrio-scheda-tecnica-b58e7e9948e09c833ae4d155f8849cac.pdf";